import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import { useTripPlannerEventBus } from 'tripPlanner/assistant/contexts/TripPlannerEventBus'

const Note = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  color: ${props => props.theme.palette.neutral.default.three};
`

/**
 * Older cart widgets in scroll-back collapse to this line. The widget hydrates live
 * cart data, so leaving several of them interactive would show competing totals and
 * checkout buttons for the same cart at different points in the conversation.
 */
function ChatCartHistoricalNote() {
  const intl = useIntl()
  const eventBus = useTripPlannerEventBus()

  const handleViewCart = useCallback(() => {
    eventBus.dispatch({ type: 'open_cart_panel' })
  }, [eventBus])

  return (
    <Note data-testid="chat-cart-historical">
      <LineShoppingCartIcon size="S" />
      <BodyText variant="small" colour="neutral-three">
        {intl.formatMessage({
          id: '2826GtnAuAvD5_6arYqA',
          defaultMessage: 'Your cart was shown here',
          description: 'Placeholder shown in place of an older inline cart widget further back in the trip planner chat history',
        })}
      </BodyText>
      <TextLink size="caption" onClick={handleViewCart}>
        {intl.formatMessage({
          id: 'xTKNX84tSnJU3kPHy_qW',
          defaultMessage: 'View cart',
          description: 'Link beside an older inline cart placeholder that reopens the trip planner cart panel',
        })}
      </TextLink>
    </Note>
  )
}

export default ChatCartHistoricalNote
